import {RESET_THEME, SET_INITIAL_THEME, SET_TEXT_SECONDARY_COLOR, SET_CORNER_RADIUS, SET_VISUALIZER_FILTERS, SET_PRODUCT_CARD_FIELDS, SET_ANALYTICS_ENABLED } from "./settingsActionTypes";
import {SET_LOGO, SET_VENDOR_NAME, SET_PRIMARY_COLOR, SET_SECONDARY_COLOR, SET_FONT, SET_LANGUAGE, SET_PRODUCTS_ORDER, SET_ORDER_BUTTON_LABEL, SET_ORDER_BUTTON_ACTION, SET_UNIT_DISPLAY} from "./settingsActionTypes";

export const setTextSecondaryColor = (color) => {
    return {
        type: SET_TEXT_SECONDARY_COLOR,
        payload: color
    };
};

export const setPrimaryColor = (color) => {
    return {
        type: SET_PRIMARY_COLOR,
        payload: color
    };
};

export const setSecondaryColor = (color) => {
    return {
        type: SET_SECONDARY_COLOR,
        payload: color
    };
};

export const setFont = (font) => {
    return {
        type: SET_FONT,
        payload: font
    };
};

export const setLanguage = (lng) => {
    return {
        type: SET_LANGUAGE,
        payload: lng
    };
};

export const setLogo = (fonts) => {
    return {
        type: SET_LOGO,
        payload: fonts
    };
};

export const setCompanyName = (name) => {
    return {
        type: SET_VENDOR_NAME,
        payload: name
    };
};

export const setProductsOrder = (name) => {
    return {
        type: SET_PRODUCTS_ORDER,
        payload: name
    };
};

export const resetTheme = () => {
    return {
        type: RESET_THEME
    };
};

export const setInitialTheme = () => {
    return {
        type: SET_INITIAL_THEME
    };
};

export const setOrderButtonLabel = (label) => {
    return {
        type: SET_ORDER_BUTTON_LABEL,
        payload: label
    };
};

export const setOrderButtonAction = (action) => {
    return {
        type: SET_ORDER_BUTTON_ACTION,
        payload: action
    };
};

/**
 * Whether this vendor's visualizer measures usage at all.
 *
 * Drives which menus are worth showing: with measurement off, leads, analytics, activity
 * and email marketing have nothing behind them. See the vendor sidebar.
 */
export const setAnalyticsEnabled = (enabled: boolean) => {
    return {
        type: SET_ANALYTICS_ENABLED,
        payload: enabled
    };
};

export const setUnitDisplay = (unit) => {
    return {
        type: SET_UNIT_DISPLAY,
        payload: unit
    };
};

export const setCornerRadius = (radius) => {
    return {
        type: SET_CORNER_RADIUS,
        payload: radius
    };
};

export const setVisualizerFilters = (filters) => {
    return {
        type: SET_VISUALIZER_FILTERS,
        payload: filters
    };
};

export const setProductCardFields = (fields) => {
    return {
        type: SET_PRODUCT_CARD_FIELDS,
        payload: fields
    };
};